import { TYPE_ITEMS } from "../constants/typeItems";

/*Clase que representa la entidad de Items*/
export class Item{

    //Constructor de la clase
    constructor(
                //Id del item
                public itemId:number,

                //Contenido html del item
                public content:string,

                //Orden visual del item dentro de una sesion
                public orderVisual:number,

                //Sesion a la que pertenece el iten
                public sesion:number,

                //Sesiones totales de la prueba
                public sesions:number,

                //Total numero de items de la sesion
                public total:number,

                //Nombre de la prueba a la que pertenece el item
                public testName:string,

                //Tipo de item (Single, grid, etc)
                public type:string,
                
                //cantidad de sub items: Para los items de tipo P2 y P4 de inglés
                public itemChild:number,
                
                //Orden del item según armado dentro de una sesion
                public order:number,
                
                /**Total que será mostrado en caso que se presenten items con numeración interna*/
	            public totalVisual:number,
                
                /**REcursos del item para Cachear */
                public recursosItem: string[],

                /** Numero de armado */
                public itemNumero:string,
                
                /** Almacena la respuesta actual */
                public respuesta:string,

                /** Flag que identifica si fue marcado */
                public marcarRespuesta: number,

                /** Almacena el itemDesencriptado */
                public contentDecrypted: string,

                public idcombo: string = "",

                public respuestaAbierta: string = ""

            ){ }

            public isOpen(): boolean{
                        
                return TYPE_ITEMS.OPEN == this.type.toLocaleLowerCase() || TYPE_ITEMS.OPEN_INSOR ==  this.type.toLocaleLowerCase()
            }
}
